import { Loader2 } from "lucide-react"
import { testIds } from "@/lib/test-ids"

/** Suspense fallback for lazy-loaded document viewer panels (Basecamp, graph, search, etc.). */
export function LazyViewFallback() {
  return (
    <div
      className="flex h-full min-h-[120px] w-full items-center justify-center text-muted-foreground"
      data-testid={testIds.documentViewer.lazyFallback}
    >
      <Loader2 className="h-8 w-8 animate-spin" aria-hidden />
    </div>
  )
}
